import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BaseApi from "../../../functions/axios";

export default function Redirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const personnelIdParam = query.get("personnelId");
    const personnelId = personnelIdParam ? Number(personnelIdParam) : null;
    const userId = localStorage.getItem("userId");

    const getUserInfo = async () => {
      try {
        const response = await BaseApi.get("user", {
          params: { user_id: userId },
        });

        const isSuccess =
          response?.status === 200 &&
          response?.data?.result === 0 &&
          Array.isArray(response?.data?.data) &&
          response.data.data.length > 0;

        if (isSuccess) {
          navigate("/personnelDetail", {
            state: {
              personnelId,
              transitionSorce: "direct",
              projectId: undefined,
            },
          });
          return;
        }
      } catch (err) {
        console.error("Redirect getUserInfo error:", err);
      }

      // 認証失敗時やデータ取得不可時はログイン画面（トップ）へリダイレクト
      navigate("/", {
        state: {
          personnelId,
          redirect: "personnelDetail",
        },
      });
    };

    getUserInfo();
  }, [navigate, location.search]);

  return null;
}